import { Environments } from '../enums'

export interface IEnvironmentConfig {
  isDev: boolean
  isProd: boolean
  dev: {
    hideWidgets: boolean
  }
}

const env: string = process.env.NODE_ENV

export const environment: IEnvironmentConfig = {
  isDev: env === Environments.DEVELOPMENT,
  isProd: env === Environments.PRODUCTION,
  dev: {
    hideWidgets: false
  }
}
